module.exports = __webpack_public_path__ + "media/images/talent/img_insurance-86fd78a50bd3034aa352100887f8b30e.png";